/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

export const LoadReception: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 24 24' {...props}>
        <G clipPath='url(#clip0_7067_34256)'>
            <Path
                d='M21.4136 10.8003L20.17 7.06941C19.9282 6.36122 19.2718 5.88622 18.5291 5.88622H18.0455C17.6136 5.88546 17.6568 5.8855 17.1818 5.8855H16.3182C15.8432 5.8855 16.3182 5.8855 15.4545 5.8858L13.7273 5.88622C12.7773 5.88622 12 6.6635 12 7.6135V11.068H2.5V15.3862C2.5 16.3362 3.27727 17.1135 4.22727 17.1135H5.09091C5.09091 18.5471 6.24818 19.7044 7.68182 19.7044C9.11545 19.7044 10.2727 18.5471 10.2727 17.1135H13.7273C13.7273 18.5471 14.8845 19.7044 16.3182 19.7044C17.7518 19.7044 18.9091 18.5471 18.9091 17.1135H21.5V11.3444C21.5 11.163 21.4741 10.9817 21.4136 10.8003ZM7.68182 17.9771C7.20682 17.9771 6.81818 17.5885 6.81818 17.1135C6.81818 16.6385 7.20682 16.2499 7.68182 16.2499C8.15682 16.2499 8.54545 16.6385 8.54545 17.1135C8.54545 17.5885 8.15682 17.9771 7.68182 17.9771ZM16.3182 17.9771C15.8432 17.9771 15.4545 17.5885 15.4545 17.1135C15.4545 16.6385 15.8432 16.2499 16.3182 16.2499C16.7932 16.2499 17.1818 16.6385 17.1818 17.1135C17.1818 17.5885 16.7932 17.9771 16.3182 17.9771ZM13.7273 11.068V7.6135H18.5291L19.6777 11.068H13.7273Z'
                fill='#E5E5E6'
            />
            <Path
                d='M2.5 5.02268C2.5 4.06874 3.27333 3.29541 4.22727 3.29541H9.40909C10.363 3.29541 11.1364 4.06874 11.1364 5.02268V10.2045H2.5V5.02268Z'
                fill='#E5E5E6'
            />
        </G>
        <Defs>
            <ClipPath id='clip0_7067_34256'>
                <Rect fill='white' />
            </ClipPath>
        </Defs>
    </Svg>
)
